// import React from "react";
import * as React from "react";

import { FaCheck, FaGift } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { TiTick } from "react-icons/ti";
import SilverPackage from "./silverPackage";
import GoldPackage from "./goldPackage";
import PlatinumPackages from "./platinumPackage";

function LifeTime() {
  const [showMore, setShowMore] = React.useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
  };
  return (
    <div>
      <div className="flex justify-between mx-10">
        {/* Silver */}
        <SilverPackage />
        {/* Gold */}
        <GoldPackage />
        {/* Platinum */}
        <PlatinumPackages />
      </div>
    </div>
  );
}

export default LifeTime;
